var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticStyle: { background: "#F7F8FA", height: "100%" } },
    [
      _c("navBar"),
      _vm._v(" "),
      _c("div", { staticClass: "register-top" }, [
        _vm._v(_vm._s(_vm.$t("home.registerNewAccount"))),
      ]),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "register-box" },
        [
          _c("div", { staticClass: "register-box-text" }, [
            _vm._v(_vm._s(_vm.$t("home.registerText"))),
          ]),
          _vm._v(" "),
          _c(
            "el-form",
            {
              ref: "form",
              attrs: { model: _vm.form, rules: _vm.rules, "label-width": "8%" },
            },
            [
              _c(
                "el-form-item",
                { attrs: { label: _vm.$t("home.account"), prop: "accountNo" } },
                [
                  _c("el-input", {
                    directives: [
                      { name: "uppercase", rawName: "v-uppercase" },
                      { name: "trim", rawName: "v-trim" },
                      { name: "fth", rawName: "v-fth" },
                    ],
                    attrs: {
                      maxlength: "20",
                      placeholder: _vm.$t("home.messagePassAccount"),
                    },
                    model: {
                      value: _vm.form.accountNo,
                      callback: function ($$v) {
                        _vm.$set(_vm.form, "accountNo", $$v)
                      },
                      expression: "form.accountNo",
                    },
                  }),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-form-item",
                {
                  attrs: {
                    label: _vm.$t("home.userName"),
                    prop: "accountName",
                  },
                },
                [
                  _c("el-input", {
                    directives: [
                      { name: "trim", rawName: "v-trim" },
                      { name: "fth", rawName: "v-fth" },
                    ],
                    attrs: {
                      maxlength: "100",
                      placeholder: _vm.$t("home.userError"),
                    },
                    model: {
                      value: _vm.form.accountName,
                      callback: function ($$v) {
                        _vm.$set(_vm.form, "accountName", $$v)
                      },
                      expression: "form.accountName",
                    },
                  }),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-form-item",
                { attrs: { label: _vm.$t("home.passWord"), prop: "password" } },
                [
                  _c(
                    "el-input",
                    {
                      directives: [
                        { name: "trim", rawName: "v-trim" },
                        { name: "fth", rawName: "v-fth" },
                      ],
                      attrs: {
                        type: _vm.passwordVisible ? "text" : "password",
                        maxlength: "100",
                        placeholder: _vm.$t("home.messagePass"),
                      },
                      model: {
                        value: _vm.form.password,
                        callback: function ($$v) {
                          _vm.$set(_vm.form, "password", $$v)
                        },
                        expression: "form.password",
                      },
                    },
                    [
                      _c(
                        "template",
                        { slot: "suffix" },
                        [
                          _vm.passwordVisible
                            ? _c("i", {
                                staticClass: "el-icon-view",
                                on: { click: _vm.handleClickIcon },
                              })
                            : _c("svg-icon", {
                                staticClass: "el-icon-close-eye",
                                attrs: { "icon-class": "eye" },
                                on: { click: _vm.handleClickIcon },
                              }),
                        ],
                        1
                      ),
                    ],
                    2
                  ),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-form-item",
                {
                  attrs: {
                    label: _vm.$t("home.surePassWord"),
                    prop: "passwordConfirm",
                  },
                },
                [
                  _c(
                    "el-input",
                    {
                      directives: [
                        { name: "trim", rawName: "v-trim" },
                        { name: "fth", rawName: "v-fth" },
                      ],
                      attrs: {
                        type: _vm.passwordConfirmVisible ? "text" : "password",
                        maxlength: "100",
                        placeholder: _vm.$t("home.messagePass"),
                      },
                      model: {
                        value: _vm.form.passwordConfirm,
                        callback: function ($$v) {
                          _vm.$set(_vm.form, "passwordConfirm", $$v)
                        },
                        expression: "form.passwordConfirm",
                      },
                    },
                    [
                      _c(
                        "template",
                        { slot: "suffix" },
                        [
                          _vm.passwordConfirmVisible
                            ? _c("i", {
                                staticClass: "el-icon-view",
                                on: { click: _vm.handleClickIconConfirm },
                              })
                            : _c("svg-icon", {
                                staticClass: "el-icon-close-eye",
                                attrs: { "icon-class": "eye" },
                                on: { click: _vm.handleClickIconConfirm },
                              }),
                        ],
                        1
                      ),
                    ],
                    2
                  ),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-form-item",
                {
                  attrs: { label: _vm.$t("home.email"), prop: "activateEmail" },
                },
                [
                  _c("el-input", {
                    directives: [
                      { name: "trim", rawName: "v-trim" },
                      { name: "fth", rawName: "v-fth" },
                    ],
                    model: {
                      value: _vm.form.activateEmail,
                      callback: function ($$v) {
                        _vm.$set(_vm.form, "activateEmail", $$v)
                      },
                      expression: "form.activateEmail",
                    },
                  }),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "register-radio-box" },
        [
          _c(
            "el-checkbox",
            {
              attrs: { label: "1" },
              model: {
                value: _vm.checked,
                callback: function ($$v) {
                  _vm.checked = $$v
                },
                expression: "checked",
              },
            },
            [
              _c("div", { on: { click: _vm.handleOpen } }, [
                _vm._v(" " + _vm._s(_vm.$t("home.agreeRegisterText"))),
              ]),
            ]
          ),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "el-button",
        {
          staticClass: "btn-primary register-buttom",
          on: { click: _vm.handleRegister },
        },
        [_vm._v(_vm._s(_vm.$t("home.submitRegister")))]
      ),
      _vm._v(" "),
      _c(
        "el-dialog",
        {
          staticClass: "descriTion",
          attrs: {
            "close-on-click-modal": false,
            visible: _vm.dialogVisible,
            width: "80%",
          },
          on: {
            "update:visible": function ($event) {
              _vm.dialogVisible = $event
            },
          },
        },
        [_c("p", { domProps: { innerHTML: _vm._s(_vm.termContent) } })]
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }